import React from "react";
import "./Contact.css";
import { VscGithub } from "react-icons/vsc";
import { CgMail } from "react-icons/cg";
import {  BsFillTelephoneFill } from "react-icons/bs";
import { ThemeContext } from "../../Context/theme";

import { FaLinkedin } from "react-icons/fa";
export const Contact = () => {
  const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
      <div className="section">
        <h2 className="section__title" data-aos="fade-right">
          Get in <span className="different">Touch</span>
        </h2>
        <div className={"contactcontainer " + themename} data-aos="fade-right">
       
         <a
            href="https://www.linkedin.com/in/mamata-ingole-53b5281b2/"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedin className="linkedin" />
          </a>
          <a
            href="https://github.com/mamataingole125"
            target="_blank"
            rel="noreferrer"
          >
            <VscGithub className="github" />
          </a>

          
         
          <a
            href="mailto:mamataingole125@gmail.com"
            target="_blank"
            rel="noreferrer"
          >
           <div className="both1"> <div><CgMail className="email" /></div><div className="gmail">mamataingole125@gmail.com</div></div>
          </a>
          <a href="tel:+917385359456" target="_blank" rel="noreferrer">
           <div className="both2"><div> <BsFillTelephoneFill className="phone" /></div><div className="phnumber">7385359456</div> </div>
          </a>
         
        </div>
      </div>
    </>
  );
}